import {
  AnchorButton,
  Button,
  ButtonGroup,
  Classes,
  ControlGroup,
  HTMLSelect,
  Label,
  Tag,
  Tooltip,
} from "@blueprintjs/core";
import "@blueprintjs/core/lib/css/blueprint.css";

import { DatePicker } from "@blueprintjs/datetime";
import { IRegion } from "@blueprintjs/table";
import "@blueprintjs/table/lib/css/table.css";
import { CollectionReference, Query } from "@firebase/firestore-types";
import { Businesses, Users } from "@just-in-types";

import * as firebase from "firebase";
import { FireSQL } from "firesql";
import * as React from "react";
import styled from "react-emotion";
import { connect } from "react-redux";
import SitePicker, { Selected } from "../../components/SitePicker";
import { firestore } from "../../firebase";
import { IState } from "../../store";

import { IBusinessRefsObject, watchDailyCheckIns } from "../../store/actions";
import "../../styles/checkinsidx.css";
import ActiveCheckIn from "./ActiveCheckIn";
import Table from "./Table";
import ViewOptions from "./ViewOptions";

export type CheckInsColumnOptions = "previewOptions" | "tableOptions";

interface ICheckInsStateProps {
  businessPermissions: IBusinessRefsObject | null;
  businesses: Businesses.Business[];
  currentUser: Users.UserWithAccount | null;
  dailyCheckIns: IState["checkIns"]["dailyCheckIns"];
  dailyCheckInsSubscription: IState["checkIns"]["dailyCheckInsSubscription"];
}

interface PageChange {
  direction: "next" | "prev";
  el: any;
}
interface PageTapChange {
  cPage: number,
  direction: "next" | "prev";
  el: any;
  fCheckIn:any;
}

interface PageChangeTearAPart {
  kiosk : PageTapChange[];
}

type CheckInsProps = ICheckInsStateProps;

const tagStyle = {
  backgroundColor: "#0D47F0",
};
const tagNumStyle = {
  backgroundColor: "white",
};

const searchBtnStyle = {
  background: "#0D47F0",
  borderRadius: "50%",
  color: "white",
  marginLeft: "5px",
};
// const filterDateArrow = {
//       background: "#0D47F0",
//       borderRadius:"50%",
//       color:"white",
//     };

const docStyle = {
  color: "gray",
};
const arrowStyle = {
  background: "#0D47F0",
  borderRadius: "50%",
  color: "white",
};

interface ModeArr{
  background? : string;
  fontColor? : string;
  mode: string;
  tableBgColor?:string;
  tableBorder?:string;
  tableFontColor?:string;
}

interface ICheckInsState {
  activeCheckIn: null | Users.CheckIn;
  businessId: null | string;
  businessPath: null | string;
  checkIns: Users.CheckIn[];
  currentPage: number;
  dailyCheckInStat:number;
  dailyOptOuts: number | string;
  darkmode: string;
  filterDate: null | Date;
  filterMobile: string | null;
  filterMobileCount: number | string;
  filterMobileInput: string;
  filterStat: string;
  filterValue: string;
  firstCheckIn: null | object;
  fontSize: number;
  isFilterByName: boolean;
  lastCheckIn: null | object;
  leftTableReload:boolean;
  loading: boolean;
  loadingLastCheckIn: boolean;
  modeArr : ModeArr;
  newCheckinCount:number;
  numRows:number;
  checkInsList: any[];
  recheck:number;
  siteId: null | string;
  sitePath: null | string;
  showDatePicker: boolean;
  streamActiveCheckIn: boolean;
  previewOptions: Users.ColumnOptions[];
  tableOptions: Users.ColumnOptions[];
  userNotes: any[];
  vehicleState:{};
  voidStat:number;
}

interface MobileObject {
  key: string;
  value: string;
}

interface TearAPart {
  ogdenCheckInsList: any[];
  ogdenFirstCheckIn : any[];
  ogdenKeyCheckIn : any[];
  ogdenLastCheckIn : any[];
  slcCheckInsList: any[];
  slcFirstCheckIn : any[];
  slcKeyCheckIn : any[];
  slcLastCheckIn : any[];
}

type CheckInsState = ICheckInsState & TearAPart;

const CheckInsWrapper = styled("div")`
  flex: 1;
  display: flex;
  margin: 0 auto;
  width: 100%;
`;
const ActiveCheckInWrapper = styled("div")`
  flex: 1 0;
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  max-height: 90vh;
  padding: 0.5rem;
`;

const LookupWrapper = styled("div")`
  margin: 2px;
`;

const PaginationWrapper = styled("div")`
  margin-bottom: 5px;
`;

const TableWrapper = styled("div")`
  flex: 2 1;
  display: flex;
  flex-direction: column;
  justify-content: stretch;
  align-items: stretch;
  max-height: 90vh;
  padding: 0.5rem;
`;
const SitePickerWrapper = styled("div")`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.5rem;
`;

const KioskButton: React.SFC<{
  disabled: boolean;
  businessPath: null | string;
  sitePath: null | string;
}> = ({ businessPath, disabled, sitePath }) => (
  <Tooltip content="choose a kiosk using the dropdown to the left" disabled={!disabled}>
    <span id="open-kiosk-style">
      <AnchorButton
        disabled={disabled}
        intent="primary"
        href={`https://kiosk.texnrewards.com/${businessPath}/${sitePath}`}
        target="_blank"
      >
        Go To Kiosk
      </AnchorButton>
    </span>
  </Tooltip>
);


export class CheckIns extends React.Component<CheckInsProps, CheckInsState> {
  private unsubscribe: () => void;
  private checkInsRef = firestore.collection("checkIns");

  // private numRows = 35;
  private defaultPreviewOptions: Users.ColumnOptions[] = [
    { enabled: true, name: "mugshot" },
    { enabled: true, name: "signature" },
    { enabled: true, name: "name" },
    { enabled: true, name: "coupons" },
    { enabled: false, name: "vehicles" },
    { enabled: true, name: "language" },
    { enabled: true, name: "mobile" },
    { enabled: true, name: "timestamp" },
    { enabled: false, name: "dateofbirth" },
    { enabled: false, name: "email" },
    { enabled: false, name: "site" },
    { enabled: false, name: "supercard" },
    { enabled: true, name: "waiver" },
    { enabled: false, name: "zip" },
  ];
  private defaultTableOptions: Users.ColumnOptions[] = [
    { enabled: true, name: "name" },
    { enabled: true, name: "mobile" },
    { enabled: true, name: "time" },
    { enabled: true, name: "mugshot" },
    { enabled: true, name: "date" },
    { enabled: true, name: "site" },
    { enabled: false, name: "timestamp" },
    { enabled: false, name: "dateofbirth" },
    { enabled: false, name: "covidquestions" },
    { enabled: false, name: "supercard" },
  ];
  // private defaultTableOptions: Users.ColumnOptions[] = [
  //   { enabled: true, name: "name" },
  //   { enabled: true, name: "mugshot" },
  //   { enabled: true, name: "mobile" },
  //   { enabled: true, name: "timestamp" },
  //   { enabled: false, name: "dateofbirth" },
  //   { enabled: true, name: "site" },
  //   { enabled: false, name: "covidquestions" },
  //   { enabled: false, name: "supercard" },
  // ];

  public constructor(props: CheckInsProps) {
    super(props);
    // console.log("proops.. ");
    // console.log(this.props.businesses[0]);

    const checkIns = [];
    const { previewOptions, tableOptions } = this.getOptionsFromUser();

    this.state = {
      activeCheckIn: null,
      businessId: null,
      businessPath: null,
      checkIns,
      checkInsList: [],
      currentPage: 1,
      dailyCheckInStat:0,
      dailyOptOuts: "...",
      darkmode: "#E5E5E5",
      filterDate: null,
      filterMobile: "",
      filterMobileCount: "...",
      filterMobileInput: "",
      filterStat: "Daily",
      filterValue: "Phone Number",
      firstCheckIn: null,
      fontSize: 12,
      isFilterByName: false,
      lastCheckIn: null,
      leftTableReload:true,
      loading: true,
      loadingLastCheckIn: true,
      modeArr:{
        background:'',
        fontColor:'',
        mode:'',
        tableBgColor:'',
        tableBorder:'',
        tableFontColor:''
      },
      newCheckinCount:0,
      numRows:35,
      ogdenCheckInsList: [],
      ogdenFirstCheckIn : [],
      ogdenKeyCheckIn : [],
      ogdenLastCheckIn : [],
      previewOptions,
      recheck:0,
      showDatePicker: false,
      siteId: null,
      sitePath: null,
      slcCheckInsList: [],
      slcFirstCheckIn : [],
      slcKeyCheckIn : [],
      slcLastCheckIn : [],
      streamActiveCheckIn: true,
      tableOptions,
      userNotes: [],
      vehicleState:{},
      voidStat:0,
    };

    this.searchByMobile = this.searchByMobile.bind(this);
    this.handleAddNewPicksFunc = this.handleAddNewPicksFunc.bind(this);
  }

  public searchByMobile(mobile){
    this.setMobileFilter(mobile);
  }

  public handleAddNewPicksFunc(mobile){
    // const { vehicleState } = this.state;
    this.setState({ vehicleState : mobile });
  }

  public componentDidUpdate({ currentUser: prevCurrentUser }: CheckInsProps, { checkIns:prevCheckIns }: CheckInsState) {
    const { currentUser } = this.props;

    if (prevCurrentUser === null && currentUser) {
      const { previewOptions, tableOptions } = this.getOptionsFromUser();
      this.setState({ previewOptions, tableOptions });
    }
    const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");

    if(prevCheckIns !== this.state.checkIns && scrollbox && scrollbox.scrollTop){
      this.setState({ leftTableReload : false });
    }

    if(prevCheckIns !== this.state.checkIns){
      const { businessId, siteId} = this.state;
      this.calcRecheckFunc(businessId, siteId);
      this.calcChechInFunc(businessId, siteId);
      // this.calcNewCustFunc(businessId, siteId);
      this.voidCheckInFunc(businessId, siteId);
      this.newCheckinFunc(businessId, siteId);
    }
  }

  public componentWillUnmount() {
    const { dailyCheckInsSubscription } = this.props;
    if (dailyCheckInsSubscription) {
      dailyCheckInsSubscription();
    }
    if (this.unsubscribe) {
      this.unsubscribe();
    }
    const matches = document.getElementsByClassName("css-1k7bvv7");
    matches[0].classList.remove("css-1k7bvv71");

    const mainContainer =  document.querySelector<HTMLElement>('.css-1k7bvv7')!;
    mainContainer.style.background = "#E5E5E5";

    const headerblock = document.getElementById("header_dm_block");
    if (headerblock) {
      headerblock.classList.remove("act_chk_head");
    }
  }

  public updateUserPrefs = (
    columnOptions: Users.ColumnOptions[],
    path: CheckInsColumnOptions,
    user: Users.UserWithAccount
  ) =>
    firestore
      .collection("users")
      .doc(user.userId)
      .update({
        [`siteOptions.checkIns.${path}`]: columnOptions,
      })
      .catch((error) => console.error(error));

  public updateColumnOptions = async (columnOptions: Users.ColumnOptions[], path: CheckInsColumnOptions) => {
    const { currentUser } = this.props;

    this.setState(({ checkIns, ...state }) => ({
      ...state,
      [path]: columnOptions,
    }));

    if (currentUser) {
      await this.updateUserPrefs(columnOptions, path, currentUser);
    }
  };

  public setFontSize = (fontSizeSetter: (fontSize: number) => number) =>
    this.setState({ fontSize: fontSizeSetter(this.state.fontSize) });

  public render() {
    const { currentUser } = this.props;
    // const { dailyCheckIns, currentUser } = this.props;
    const {
      activeCheckIn,
      businessId,
      businessPath,
      checkIns,
      currentPage,
      dailyOptOuts,
      darkmode,
      filterMobile,
      filterMobileCount,
      fontSize,
      loading,
      loadingLastCheckIn,
      numRows,
      previewOptions,
      showDatePicker,
      siteId,
      sitePath,
      tableOptions,
      userNotes,
    } = this.state;
    const kioskButtonDisabled = !businessPath || businessPath === "all" || !sitePath || sitePath === "all"|| sitePath === "ogden"|| sitePath === "slc";

    const currentUserEmail = currentUser ? currentUser.accountData.email : "";

    return (
      <div id="chkinwrap_main_block" style={{ background: darkmode }}>
        <CheckInsWrapper>
          <ActiveCheckInWrapper style={{marginRight:"20px"}}>
            <div id="active-checkin-style">
              <ActiveCheckIn
                businessId={businessId}
                // changeMarkForTheft={this.handleMarkForTheft}
                checkIn={activeCheckIn}
                currentUser={currentUser}
                previewOptions={previewOptions}
                siteId={activeCheckIn?activeCheckIn.siteId:''}
                // siteId={siteId}
                searchByMobile={ this.searchByMobile }
                handleAddNewPicksFunc={ this.handleAddNewPicksFunc }
                updateMembership={() => this.watchCheckIns(businessId ? businessId : "", siteId)}
              />
            </div>
          </ActiveCheckInWrapper>
          <TableWrapper>
            <SitePickerWrapper>
              <div id="act-checkin-wrap">
                <SitePicker
                  childrenRight={
                    <ViewOptions
                      fontSize={fontSize}
                      modeArr={this.state.modeArr}
                      onSetFontSize={this.setFontSize}
                      onUpdateColumnOptions={this.updateColumnOptions}
                      previewOptions={previewOptions}
                      tableOptions={tableOptions}
                    />
                  }
                  filter={true}
                  hasAll={true}
                  onSelect={this.handleNewKioskSelection}
                />
              </div>
              <ButtonGroup>
                {process.env.NODE_ENV === "development" && (
                  <Button intent="danger" onClick={this.clearTestCheckIns}>
                    clear tests
                  </Button>
                )}
                <KioskButton businessPath={businessPath} disabled={kioskButtonDisabled} sitePath={sitePath} />
              </ButtonGroup>
            </SitePickerWrapper>
            <div id="daily-cnt-n-kisk-block">
              <ControlGroup>
                <div id="filter-stat-style">
                  <HTMLSelect
                    options={["Daily", "Weekly", 'Monthly']}
                    onChange={this.handleStatChange}
                    value={this.state.filterStat}
                  />
                </div>    
                &nbsp;
                <div id="daily-cnt-style">
                  <Tag style={tagStyle} large={true}>
                    Check-Ins
                  </Tag>
                  <Tag style={tagNumStyle} large={true} minimal={true}>
                    {this.state.dailyCheckInStat}
                    {/* {dailyCheckIns} */}
                  </Tag>
                </div>
                &nbsp;
                <div id="new-customer-style">
                  <Tag style={tagStyle} large={true}>
                    New VIP Subscribers
                  </Tag>
                  <Tag style={tagNumStyle} large={true} minimal={true} id="new-cust-count">
                    {this.state.newCheckinCount}
                  </Tag>
                </div>
                &nbsp;
                <div id="daily-kisk-style">
                  <Tag style={tagStyle} large={true}>
                    Kiosk Opt-Outs
                  </Tag>
                  <Tag style={tagNumStyle} large={true} minimal={true}>
                    {dailyOptOuts}
                  </Tag>
                </div>
                &nbsp;
                <div id="re-check-style">
                  <Tag style={tagStyle} large={true}>
                    Re-Check
                  </Tag>
                  <Tag style={tagNumStyle} large={true} minimal={true}>
                    {this.state.recheck}
                  </Tag>
                </div>
                &nbsp;
                <div id="void-stat-style">
                  <Tag style={tagStyle} large={true}>
                    Voids
                  </Tag>
                  <Tag style={tagNumStyle} large={true} minimal={true}>
                    {this.state.voidStat}
                  </Tag>
                </div>
              </ControlGroup>
            </div>
            <div id="filter_name_n_phone_block">
              <LookupWrapper>
                <div id="filter-sec-style">
                  <ControlGroup>
                    <HTMLSelect
                      options={["Phone Number", "Name"]}
                      onChange={this.handleFilterChange}
                      value={this.state.filterValue}
                    />
                    &nbsp;
                    <Label className={Classes.INLINE}>
                      :
                      <input
                        className={Classes.INPUT}
                        onChange={(event) =>
                          this.setState({
                            filterMobileInput: event.currentTarget.value,
                          })
                        }
                        value={this.state.filterMobileInput}
                      />
                      <Button
                        style={searchBtnStyle}
                        onClick={() => {
                          this.setMobileFilter(this.state.filterMobileInput);
                        }}
                        icon="search"
                      />
                    </Label>
                  </ControlGroup>
                </div>
                {filterMobile && filterMobile !== "" ? (
                  <ControlGroup>
                    <Tag
                      active={true}
                      onRemove={() =>
                        {
                          if(businessId){
                            this.watchCheckIns(businessId, siteId);
                            this.setState({ currentPage: 1 });
                          }else{
                            console.log("missing business");
                          }
                        }
                      }
                    >
                      {typeof filterMobile === "object"
                        ? // tslint:disable-next-line:no-string-literal
                          filterMobile["value"]
                        : filterMobile}
                    </Tag>
                    <span style={{ marginLeft: "5px" }}>
                      <Tag large={true}>{typeof filterMobile === "object" ? "Results" : "Check-ins by user"}</Tag>
                      <Tag large={true} minimal={true} style={{ color:"#fff"}}>
                        {filterMobileCount}
                      </Tag>
                    </span>
                  </ControlGroup>
                ) : (
                  ""
                )}
              </LookupWrapper>
            </div>  
            <div id="filter-date-style">
              <PaginationWrapper>
                <span>
                  {siteId === "ogden1" || siteId === "slc1"?
                    (
                      <Button
                        style={arrowStyle}
                        icon="arrow-left"
                        disabled={currentPage === 1 || loadingLastCheckIn}
                        onClick={() => this.prevTapPage(currentPage)}
                      />
                    ):
                    ( 
                      <Button
                        style={arrowStyle}
                        icon="arrow-left"
                        disabled={currentPage === 1 || loadingLastCheckIn}
                        onClick={() => this.prevPage(currentPage)}
                      />
                    )
                  }
                  <Button style={docStyle} icon="document">
                    {currentPage}
                  </Button>
                  {siteId === "ogden1" || siteId === "slc1"?
                    (
                      <Button
                        style={arrowStyle}
                        icon="arrow-right"
                        disabled={loadingLastCheckIn}
                        onClick={() => this.nextTapPage(currentPage)}
                      />
                    ):
                    (
                      <Button
                        style={arrowStyle}
                        icon="arrow-right"
                        disabled={loadingLastCheckIn}
                        onClick={() => this.nextPage(currentPage)}
                      />
                    )
                  }
                  &nbsp; &nbsp;
                  <span id="calender-style">
                  {siteId === "ogden1" || siteId === "slc1"?
                    (
                      <Button
                        rightIcon={"calendar"}
                        text={"Date"}
                        onClick={() => {
                          this.setState({ showDatePicker: false });
                        }}
                      />
                    ):
                    (
                      <Button
                        rightIcon={"calendar"}
                        text={"Date"}
                        onClick={() => {
                          this.setState({ showDatePicker: !showDatePicker });
                        }}
                      />
                    )
                  }
                  </span>
                  {showDatePicker ? <DatePicker className={"datepicker"} onChange={this.handleDateChange} /> : ""}
                </span>
                &nbsp; &nbsp;
                {siteId === "ogden1" || siteId === "slc1"?
                  (
                    <HTMLSelect  id="rows_of_table"
                      options={[ 'Show ' + 35, 'Show ' + 150, 'Show ' + 250, 'Show ' + 500, 'Show ' + 750, 'Show ' + 1000]}
                      // onChange={this.handleRowsNoChange}
                      style={{color: "#fff", background: "#0d47f0"}}
                      value={'Show ' + numRows}
                      disabled={true}
                    />
                  ):
                  (
                    <HTMLSelect  id="rows_of_table"
                      options={[ 'Show ' + 35, 'Show ' + 150, 'Show ' + 250, 'Show ' + 500, 'Show ' + 750, 'Show ' + 1000]}
                      onChange={this.handleRowsNoChange}
                      style={{color: "#fff", background: "#0d47f0"}}
                      value={'Show ' + numRows}
                    />
                  )
                }

              </PaginationWrapper>
            </div>
            <Table
              businessId={businessId ? businessId : ""}
              checkIns={checkIns}
              currentUser={currentUser}
              currentUserEmail={currentUserEmail ? currentUserEmail : ""}
              fontSize={fontSize}
              loading={loading}
              numRows={numRows}
              // numRows={siteId === 'odgen' || siteId === 'slc' ?300:numRows}
              onSetActiveCheckIn={this.setActiveCheckIn}
              siteId={siteId ? siteId : ""}
              tableOptions={tableOptions}
              userNotes={userNotes}
              vehicleState={this.state.vehicleState}
            />
          </TableWrapper>
        </CheckInsWrapper>
      </div>
    );
  }

  // private handleMarkForTheft = (markForTheft, userId)=>{
  //   console.log(markForTheft + userId);
  //   console.log("oooooooooooooooooooooooooooooooooooo");
  //   console.log(this.state.checkIns);
  //   // this.setState({checkIns});
  //   // if(this.state.checkIns){
  //   //   const checkIns = [...this.state.checkIns];

  //   //   let checkIn;
  //   //   checkIns.forEach((ele, index)=>{
  //   //     if(ele.userId === userId){
  //   //       checkIn = {...checkIns[index]};
  //   //       checkIn.markForTheft = markForTheft;
  //   //       checkIns[index] = checkIn;
  //   //     }
  //   //     checkIn = null;
  //   //   });
  //   //   // console.log(checkIns[0]);
  //   //   this.setState({ checkIns });
  //   // }
  // }

  private handleFilterChange = ({ currentTarget: { value } }: React.ChangeEvent<HTMLSelectElement>) => {
    const filterValue = value;

    this.setState({ filterValue });
  };
  
  private handleStatChange = async ({ currentTarget: { value } }: React.ChangeEvent<HTMLSelectElement>) => {
    const filterStat = value;
    const { businessId, siteId} = this.state;

    await this.setState({ filterStat });
    this.voidCheckInFunc(businessId, siteId);
    // this.newCheckinFunc(businessId, siteId);
    this.calcRecheckFunc(businessId, siteId);
    this.calcChechInFunc(businessId, siteId);
    this.watchOptOutsCount(businessId, siteId);
  };

  private handleRowsNoChange = ({ currentTarget: { value } }: React.ChangeEvent<HTMLSelectElement>) => {
    const { siteId: siteIdState, businessId: businessIdState } = this.state;
    const rowsValue = value.replace("Show ", "");
    const numRows = Number(rowsValue);
    this.setState({ numRows });
    
    // const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
    // if (scrollbox && scrollbox.scrollTop) {
    //   scrollbox.scrollTop = 0;
    // }

    if(businessIdState){
      setTimeout(() => {
        this.watchCheckIns(businessIdState, siteIdState);
      }, 1000)
    }
  };

  private setMobileFilter = (mobile) => {
    const { siteId: siteIdState, businessId: businessIdState, filterValue } = this.state;

    if (businessIdState) {
      if (mobile && filterValue === "Name") {
        mobile = {
          key: "name",
          value: mobile.charAt(0).toUpperCase() + mobile.slice(1),
        };
      }
      this.watchCheckIns(businessIdState, siteIdState, mobile);
      this.setState({ filterMobile: mobile, currentPage: 1 });

      const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
      if (scrollbox && scrollbox.scrollTop) {
        scrollbox.scrollTop = 0;
      }
    }
  };

  private prevPage = (currentPage) => {
    const { checkInsList, siteId: siteIdState, businessId: businessIdState, filterMobile } = this.state;
    this.setState({ currentPage: currentPage - 1 });
    const el = checkInsList.pop();
    if (businessIdState) {
      this.watchCheckIns(businessIdState, siteIdState, filterMobile, {
        direction: "prev",
        el,
      });
    }
    const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
    if (scrollbox && scrollbox.scrollTop) {
      scrollbox.scrollTop = 0;
    }
  };

  private prevTapPage = (currentPage) => {
    const {       
          ogdenCheckInsList,
          slcCheckInsList,
          ogdenFirstCheckIn,
          slcFirstCheckIn,
          siteId: siteIdState,
          businessId: businessIdState,
          filterMobile } = this.state;
    this.setState({ currentPage: currentPage - 1 });
    const elOgden = ogdenCheckInsList.pop();
    const elSlc = slcCheckInsList.pop();
    if (businessIdState) {
      this.watchCheckIns(businessIdState, siteIdState, filterMobile, null, [
        {
          cPage:(currentPage),
          direction: "prev",
          el: elOgden,
          fCheckIn:ogdenFirstCheckIn,
        },
        {
          cPage:(currentPage),
          direction: "prev",
          el: elSlc,
          fCheckIn:slcFirstCheckIn,
        }
      ]);
    }
    const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
    if (scrollbox && scrollbox.scrollTop) {
      scrollbox.scrollTop = 0;
    }
  };

  private nextPage = (currentPage) => {
    const {
      checkInsList,
      firstCheckIn,
      lastCheckIn,
      siteId: siteIdState,
      businessId: businessIdState,
      filterMobile,
    } = this.state;
    checkInsList.push(firstCheckIn);
    this.setState({ currentPage: currentPage + 1, checkInsList });
    if (businessIdState) {
      this.watchCheckIns(businessIdState, siteIdState, filterMobile, {
        direction: "next",
        el: lastCheckIn,
      });
    }
    const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
    if (scrollbox && scrollbox.scrollTop) {
      scrollbox.scrollTop = 0;
    }
  };

  private nextTapPage = (currentPage) => {
    const {
      ogdenCheckInsList,
      slcCheckInsList,
      ogdenFirstCheckIn,
      slcFirstCheckIn,
      ogdenLastCheckIn,
      slcLastCheckIn,
      siteId: siteIdState,
      businessId: businessIdState,
      filterMobile,
    } = this.state;
    ogdenCheckInsList.push(ogdenFirstCheckIn);
    slcCheckInsList.push(slcFirstCheckIn);
    this.setState({ currentPage: currentPage + 1, ogdenCheckInsList, slcCheckInsList });
    if (businessIdState) {
      this.watchCheckIns(businessIdState, siteIdState, filterMobile, null, [
        {
          cPage:(currentPage+1),
          direction: "next",
          el: ogdenLastCheckIn,
          fCheckIn:ogdenFirstCheckIn,
        },
        {
          cPage:(currentPage+1),
          direction: "next",
          el: slcLastCheckIn,
          fCheckIn:slcFirstCheckIn,
        }
      ]);
    }
    const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
    if (scrollbox && scrollbox.scrollTop) {
      scrollbox.scrollTop = 0;
    }
  };

  private handleDateChange = async (date, isUserChange) => {
    const {
      siteId: siteIdState,
      businessId: businessIdState,
      // filterMobile,
    } = this.state;
    if (!isUserChange) {
      // if this date wasn't picked directly by the user, don't do anything
      return;
    }
    console.log("INPUT DATE:");
    console.log(date);
    if (date !== null) {
      date.setHours(0, 0, 0, 0);
    }
    await this.setState({ filterDate: date });
    if (businessIdState) {
      this.watchCheckIns(businessIdState, siteIdState, null, null);
    }
    this.setState({ showDatePicker: false });
  };

  private dedupe = (optionsArr: Users.ColumnOptions[]) =>
    optionsArr.filter(
      (options, index, arr) => arr.map((mapOptions) => mapOptions.name).indexOf(options.name) === index
    );

  private dedupeUserOptions = ({
    userPreviewOptions,
    userTableOptons,
  }: {
    userPreviewOptions: Users.ColumnOptions[];
    userTableOptons: Users.ColumnOptions[];
  }) => {
    const previewOptions = this.dedupe([...userPreviewOptions, ...this.defaultPreviewOptions]);
    const tableOptions = this.dedupe([...userTableOptons, ...this.defaultTableOptions]);
    return { previewOptions, tableOptions };
  };

  private getOptionsFromUser = () => {
    const { currentUser } = this.props;
    const userOptions =
      currentUser && currentUser.siteOptions && currentUser.siteOptions.checkIns
        ? {
            userPreviewOptions: currentUser.siteOptions.checkIns.previewOptions || [],
            userTableOptons: currentUser.siteOptions.checkIns.tableOptions || [],
          }
        : { userPreviewOptions: [], userTableOptons: [] };


    const { previewOptions, tableOptions } = this.dedupeUserOptions(userOptions);

    return { previewOptions, tableOptions };
  };

  private getMembership = async (checkIn: Users.CheckIn) => {
    const membershipQuery = await firestore
      .collection(`membership`)
      .where("mobile", "==", checkIn.mobile)
      .limit(1)
      .get();
    if (membershipQuery.size > 0) {
      const membership = membershipQuery.docs[0].data() as Users.Membership;
      checkIn.membership = membership;
      // console.log(checkIn);
      return checkIn;
    } else {
      const membership = {
        businessId: null,
        end_date: null,
        mobile: null,
        mugshot: null,
        start_date: null,
      };
      checkIn.membership = membership;
      return checkIn;
    }
  };

  private watchCheckIns = async (
    businessId: string,
    siteId: null | string,
    mobile?: string | null | MobileObject,
    changePage?: null | PageChange,
    changeTapPage?: null | PageChangeTearAPart['kiosk'],
  ) => {

    const { filterDate } = this.state;
    const numRows = this.state.numRows;
    this.setState({ loading: true, loadingLastCheckIn: true });
    if (mobile && typeof mobile === "object") {
      const fireSQL = new FireSQL(firebase.firestore());

      let sqlQuery = "SELECT * FROM checkIns WHERE ";
      if (businessId) {
        sqlQuery += `businessId = '${businessId}'`;
      }
      if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
        sqlQuery += ` AND siteId = '${siteId}'`;
      }

      if (siteId && siteId !== "all" && siteId === "ogden") {
        sqlQuery += ` AND (siteId = 'TMrSaHl6j451pEWxY7nu' OR siteId = '6vVH4qpzsVxjmROhMDmh' OR siteId = '1YYyeZ1YXjGyc6Z6vwRt')`;
      }

      if (siteId && siteId !== "all" && siteId === "slc") {
        sqlQuery += ` AND (siteId = 'FDYHKAMSiYNCuXumk5Iv' OR siteId = 'kv9ciglhFsJBh9YyV2sd' OR siteId = '17VBJyeH2crmqQC2OSxx')`;
      }

      if (mobile) {
        if (typeof mobile === "object") {
          if (mobile.key === "name") {
            sqlQuery += ` AND (`;
            sqlQuery += ` \`name.displayName\` LIKE '${mobile.value}%'`;
            sqlQuery += ` OR \`name.firstname\` LIKE '${mobile.value}%'`;
            sqlQuery += ` OR \`name.lastname\` LIKE '${mobile.value}%'`;
            sqlQuery += `)`;
          }
        }
      }

      fireSQL.query(sqlQuery).then((documents) => {
        const checkIns: Users.CheckIn[] = [];
        let count = 0;
        documents.forEach((doc) => {
          const checkIn = {
            checkInId: doc.businessId,
            ...doc,
          } as Users.CheckIn;
          checkIns.push(checkIn);

          count++;
        });

        if (mobile) {
          this.setState({ filterMobileCount: count });
        }

        this.setState({
          checkIns,
          firstCheckIn: documents[0],
          lastCheckIn: documents[documents.length - 1],
          loading: false,
          loadingLastCheckIn: false,
        });
        this.getUserNotes(checkIns);
        this.calcChechInFunc(businessId, siteId);
        if (!this.state.activeCheckIn || this.state.streamActiveCheckIn) {
          this.setActiveCheckIn([{ cols: null, rows: [0, 0] }]);
        }
      });
    } else {
      let query: CollectionReference | Query = this.checkInsRef;

      if (businessId) {
        query = query.where("businessId", "==", businessId);
      }

      if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
        query = query.where("siteId", "==", siteId);
      }
      if (siteId && siteId !== "all" && siteId === "ogden") {
        query = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh");
      }
      if (siteId && siteId !== "all" && siteId === "slc") {
        query = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd");
      }
      if (mobile) {
        query = query.where("mobile", "==", mobile);
      } else {
        this.setState({
          filterMobile: "",
          filterMobileCount: "...",
          filterMobileInput: "",
        });
      }
      if (filterDate) {
        filterDate.setDate(filterDate.getDate() + 1);
        console.log("WATCH CHECK INS DATE:");
        console.log(filterDate);
        query = query.where("timestamp", "<=", filterDate);
      }

      query = query.orderBy("timestamp", "desc");

      // if (changePage) {
      //   if (changePage.direction === "next") {
      //     query = query.startAfter(changePage.el);
      //   } else if (changePage.direction === "prev") {
      //     query = query.startAt(changePage.el);
      //   }
      // }
      // const liveUpdate = this.state.currentPage === 1;

      if(siteId === "ogden1"){

        let q1: any;
        let q2:any;
        let q3:any;

        if (changeTapPage && changeTapPage[0]) {
          if (changeTapPage[0].direction === "next") {
            q1 = changeTapPage[0].el[0]?query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").startAfter(changeTapPage[0].el[0]).limit(100).get():0;
            q2 = changeTapPage[0].el[1]?query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").startAfter(changeTapPage[0].el[1]).limit(100).get():0;
            q3 = changeTapPage[0].el[2]?query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").startAfter(changeTapPage[0].el[2]).limit(100).get():0;
          } else if (changeTapPage[1].direction === "prev") {
            // query = query.startAt(changeTapPage[1].el);
            q1 = changeTapPage[0].el[0]?query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").startAt(changeTapPage[0].el[0]).limit(100).get():0;
            q2 = changeTapPage[0].el[1]?query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").startAt(changeTapPage[0].el[1]).limit(100).get():0;
            q3 = changeTapPage[0].el[2]?query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").startAt(changeTapPage[0].el[2]).limit(100).get():0;
          }
        }else{

          q1 = query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").limit(100).get();
          q2 = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").limit(100).get();
          q3 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").limit(100).get();
        }



        //////////////////////////////////////////////
        // const query1 = query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").limit(2).get();
        // const query2 = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").limit(2).get();
        // const query3 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").limit(2).get();
        const [c1, c2, c3]  = await Promise.all([q1,q2, q3]);

        const c1Array = c1.docs;
        const c2Array = c2.docs;
        const c3Array = c3.docs;

        let finalArray:any;

        if(c3Array && typeof c3Array !== 'undefined'){
          if(c2Array && typeof c2Array !== 'undefined'){
            if( c1Array && typeof c1Array !== "undefined"){
              finalArray = c3Array.concat(c2Array.concat(c1Array));
            }else{
              finalArray = c3Array.concat(c2Array);
            }
          }else{
            if( c1Array && typeof c1Array !== "undefined"){
              finalArray = c3Array.concat(c1Array);
            }else{
              finalArray = c3Array;
            }
          }
        }else{
          if(c2Array && typeof c2Array !== 'undefined'){
            if( c1Array && typeof c1Array !== "undefined"){
              finalArray = c2Array.concat(c1Array);
            }else{
              finalArray = c2Array;
            }
          }
        }


        const checkIns: Users.CheckIn[] = [];
        finalArray.sort((a, b) => b.data().timestamp.toMillis() - a.data().timestamp.toMillis());        
        let count = 0;
        finalArray.forEach((doc) => {
          const checkIn = {
            checkInId: doc.id,
            ...doc.data(),
          } as Users.CheckIn;
          checkIns.push(checkIn);

          this.getMembership(checkIn).then((result) => {
            this.setState((prevState) => ({
              checkIns: {
                ...prevState.checkIns,
                [prevState.checkIns[count] as any]: result,
              },
            }));
          });

          count++;
        });

        if (mobile) {
          this.setState({ filterMobileCount: finalArray.length });
        }



        const { ogdenKeyCheckIn, ogdenCheckInsList } = this.state;

        if(typeof c1Array !== "undefined" && !c1Array.length && !ogdenKeyCheckIn[0]){
          
          ogdenKeyCheckIn[0] = {
            currentpage:(changeTapPage && changeTapPage[0])?changeTapPage[0].cPage:1,
            firstCheckIn:(changeTapPage && changeTapPage[0])?changeTapPage[0].fCheckIn[0]:0,
          }
        }

        if(typeof c2Array !== "undefined" && !c2Array.length && !ogdenKeyCheckIn[1]){

          ogdenKeyCheckIn[1] = {
            currentpage:(changeTapPage && changeTapPage[0])?changeTapPage[0].cPage:1,
            firstCheckIn:(changeTapPage && changeTapPage[0])?changeTapPage[0].fCheckIn[1]:0,
          }
        }

        if(typeof c3Array !== "undefined" && !c3Array.length && !ogdenKeyCheckIn[2]){
          ogdenKeyCheckIn[2] = {
            currentpage:(changeTapPage && changeTapPage[0])?changeTapPage[0].cPage:1,
            firstCheckIn:(changeTapPage && changeTapPage[0])?changeTapPage[0].fCheckIn[2]:0,
          }
        }


        if(ogdenKeyCheckIn[0] && changeTapPage && changeTapPage[0] && ogdenKeyCheckIn[0].currentpage === changeTapPage[0].cPage){
          const checkList = ogdenCheckInsList.pop();
          
          checkList[0] = ogdenKeyCheckIn[0].firstCheckIn;
          ogdenCheckInsList.push(checkList);
          ogdenKeyCheckIn[0] = 0;
          
        }

        if(ogdenKeyCheckIn[1] && changeTapPage && changeTapPage[0] && ogdenKeyCheckIn[1].currentpage === changeTapPage[0].cPage){
          const checkList = ogdenCheckInsList.pop();
          
          checkList[1] = ogdenKeyCheckIn[1].firstCheckIn;
          ogdenCheckInsList.push(checkList);
          ogdenKeyCheckIn[1] = 0;

        }

        if(ogdenKeyCheckIn[2] && changeTapPage && changeTapPage[0] && ogdenKeyCheckIn[2].currentpage === changeTapPage[0].cPage){
          const checkList = ogdenCheckInsList.pop();
          
          checkList[2] = ogdenKeyCheckIn[2].firstCheckIn;
          ogdenCheckInsList.push(checkList);
          ogdenKeyCheckIn[2] = 0;

        }

        const ogdenFirstCheckIn:any = [];
        if(c1Array){
          ogdenFirstCheckIn.push(c1Array[0]);
        }else{
          ogdenFirstCheckIn.push(0);
        }
        if(c2Array){
          ogdenFirstCheckIn.push(c2Array[0]);
        }else{
          ogdenFirstCheckIn.push(0);
        }
        if(c3Array){
          ogdenFirstCheckIn.push(c3Array[0]);
        }else{
          ogdenFirstCheckIn.push(0);
        }

        const ogdenLastCheckIn:any = [];

        if(c1Array){
          ogdenLastCheckIn.push(c1Array[c1Array.length-1]);
        }else{
          ogdenLastCheckIn.push(0);
        }
        if(c2Array){
          ogdenLastCheckIn.push(c2Array[c2Array.length-1]);
        }else{
          ogdenLastCheckIn.push(0);
        }
        if(c3Array){
          ogdenLastCheckIn.push(c3Array[c3Array.length-1]);
        }else{
          ogdenLastCheckIn.push(0);
        }




        this.setState({
          checkIns,
          // firstCheckIn: finalArray[0],
          // lastCheckIn: finalArray[finalArray.length - 1],
          loading: false,
          loadingLastCheckIn: false,
          ogdenCheckInsList,
          ogdenFirstCheckIn,
          ogdenKeyCheckIn,
          ogdenLastCheckIn,
        });

        this.getUserNotes(checkIns);
        this.calcChechInFunc(businessId, siteId);
      // }

      if (!this.state.activeCheckIn || this.state.streamActiveCheckIn) {
        this.setActiveCheckIn([{ cols: null, rows: [0, 0] }]);
      }

      }else if(siteId === "slc1"){

        let q1: any;
        let q2:any;
        let q3:any;

        if (changeTapPage && changeTapPage[1]) {
          if (changeTapPage[1].direction === "next") {
            q1 = changeTapPage[1].el[0]?query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").startAfter(changeTapPage[1].el[0]).limit(100).get():0;
            q2 = changeTapPage[1].el[1]?query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").startAfter(changeTapPage[1].el[1]).limit(100).get():0;
            q3 = changeTapPage[1].el[2]?query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").startAfter(changeTapPage[1].el[2]).limit(100).get():0;
          } else if (changeTapPage[1].direction === "prev") {
            // query = query.startAt(changeTapPage[1].el);
            q1 = changeTapPage[1].el[0]?query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").startAt(changeTapPage[1].el[0]).limit(100).get():0;
            q2 = changeTapPage[1].el[1]?query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").startAt(changeTapPage[1].el[1]).limit(100).get():0;
            q3 = changeTapPage[1].el[2]?query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").startAt(changeTapPage[1].el[2]).limit(100).get():0;
          }
        }else{

          q1 = query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").limit(100).get();
          q2 = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").limit(100).get();
          q3 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").limit(100).get();
        }

        // const query1 = query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").limit(2).get();
        // const query2 = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").limit(2).get();
        // const query3 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").limit(2).get();
        const [c1, c2, c3]  = await Promise.all([q1,q2, q3]);

        const c1Array = c1.docs;
        const c2Array = c2.docs;
        const c3Array = c3.docs;

        let finalArray:any;

        if(c3Array && typeof c3Array !== 'undefined'){
          if(c2Array && typeof c2Array !== 'undefined'){
            if( c1Array && typeof c1Array !== "undefined"){
              finalArray = c3Array.concat(c2Array.concat(c1Array));
            }else{
              finalArray = c3Array.concat(c2Array);
            }
          }else{
            if( c1Array && typeof c1Array !== "undefined"){
              finalArray = c3Array.concat(c1Array);
            }else{
              finalArray = c3Array;
            }
          }
        }else{
          if(c2Array && typeof c2Array !== 'undefined'){
            if( c1Array && typeof c1Array !== "undefined"){
              finalArray = c2Array.concat(c1Array);
            }else{
              finalArray = c2Array;
            }
          }
        }
        const checkIns: Users.CheckIn[] = [];
  
        finalArray.sort((a, b) => b.data().timestamp.toMillis() - a.data().timestamp.toMillis());

        let count = 0;
        finalArray.forEach((doc) => {
          const checkIn = {
            checkInId: doc.id,
            ...doc.data(),
          } as Users.CheckIn;
          checkIns.push(checkIn);

          this.getMembership(checkIn).then((result) => {
            this.setState((prevState) => ({
              checkIns: {
                ...prevState.checkIns,
                [prevState.checkIns[count] as any]: result,
              },
            }));
          });

          count++;
        });

        if (mobile) {
          this.setState({ filterMobileCount: finalArray.length });
        }


        const { slcKeyCheckIn, slcCheckInsList } = this.state;

        if(typeof c1Array !== "undefined" && !c1Array.length && !slcKeyCheckIn[0]){
          slcKeyCheckIn[0] = {
            currentpage:(changeTapPage && changeTapPage[1])?changeTapPage[1].cPage:1,
            firstCheckIn:(changeTapPage && changeTapPage[1])?changeTapPage[1].fCheckIn[0]:0,
          }
        }

        if(typeof c2Array !== "undefined" && !c2Array.length && !slcKeyCheckIn[1]){

          slcKeyCheckIn[1] = {
            currentpage:(changeTapPage && changeTapPage[1])?changeTapPage[1].cPage:1,
            firstCheckIn:(changeTapPage && changeTapPage[1])?changeTapPage[1].fCheckIn[1]:0,
          }
        }

        if(typeof c3Array !== "undefined" && !c3Array.length && !slcKeyCheckIn[2]){
          slcKeyCheckIn[2] = {
            currentpage:(changeTapPage && changeTapPage[1])?changeTapPage[1].cPage:1,
            firstCheckIn:(changeTapPage && changeTapPage[1])?changeTapPage[1].fCheckIn[2]:0,
          }
        }


        if(slcKeyCheckIn[0] && changeTapPage && changeTapPage[1] && slcKeyCheckIn[0].currentpage === changeTapPage[1].cPage){
          const checkList = slcCheckInsList.pop();
          
          checkList[0] = slcKeyCheckIn[0].firstCheckIn;
          slcCheckInsList.push(checkList);
          slcKeyCheckIn[0] = 0;
          
        }

        if(slcKeyCheckIn[1] && changeTapPage && changeTapPage[1] && slcKeyCheckIn[1].currentpage === changeTapPage[1].cPage){
          const checkList = slcCheckInsList.pop();
          
          checkList[1] = slcKeyCheckIn[1].firstCheckIn;
          slcCheckInsList.push(checkList);
          slcKeyCheckIn[1] = 0;

        }

        if(slcKeyCheckIn[2] && changeTapPage && changeTapPage[1] && slcKeyCheckIn[2].currentpage === changeTapPage[1].cPage){
          const checkList = slcCheckInsList.pop();
          
          checkList[2] = slcKeyCheckIn[2].firstCheckIn;
          slcCheckInsList.push(checkList);
          slcKeyCheckIn[2] = 0;

        }

        const slcFirstCheckIn:any = [];

        if(c1Array){
          slcFirstCheckIn.push(c1Array[0]);
        }else{
          slcFirstCheckIn.push(0);
        }

        if(c2Array){
          slcFirstCheckIn.push(c2Array[0]);
        }else{
          slcFirstCheckIn.push(0);
        }

        if(c3Array){
          slcFirstCheckIn.push(c3Array[0]);
        }else{
          slcFirstCheckIn.push(0);
        }

        const slcLastCheckIn:any = [];


        if(c1Array){
          slcLastCheckIn.push(c1Array[c1Array.length-1]);
        }else{
          slcLastCheckIn.push(0);
        }

        if(c2Array){
          slcLastCheckIn.push(c2Array[c2Array.length-1]);
        }else{
          slcLastCheckIn.push(0);
        }

        if(c3Array){
          slcLastCheckIn.push(c3Array[c3Array.length-1]);
        }else{
          slcLastCheckIn.push(0);
        }

        this.setState({
          checkIns,
          // firstCheckIn: finalArray?finalArray[0]:0,
          // lastCheckIn: finalArray[finalArray.length - 1],
          loading: false,
          loadingLastCheckIn: false,
          slcCheckInsList,
          slcFirstCheckIn,
          slcKeyCheckIn,
          slcLastCheckIn,
          
        });

        this.getUserNotes(checkIns);
        this.calcChechInFunc(businessId, siteId);
      // }

        if (!this.state.activeCheckIn || this.state.streamActiveCheckIn) {
          this.setActiveCheckIn([{ cols: null, rows: [0, 0] }]);
        }

      }else{
        
        if (changePage) {
          if (changePage.direction === "next") {
            query = query.startAfter(changePage.el);
          } else if (changePage.direction === "prev") {
            query = query.startAt(changePage.el);
          }
        }
        const liveUpdate = this.state.currentPage === 1;

        this.unsubscribe = query.limit(numRows).onSnapshot(
          { includeMetadataChanges: liveUpdate },
          (checkInsSnapshot) => {
            const checkIns: Users.CheckIn[] = [];
  
            let count = 0;
            checkInsSnapshot.forEach((doc) => {
              const checkIn = {
                checkInId: doc.id,
                ...doc.data(),
              } as Users.CheckIn;
              checkIns.push(checkIn);
  
              this.getMembership(checkIn).then((result) => {
                this.setState((prevState) => ({
                  checkIns: {
                    ...prevState.checkIns,
                    [prevState.checkIns[count] as any]: result,
                  },
                }));
              });
  
              count++;
            });
  
            if (mobile) {
              this.setState({ filterMobileCount: checkInsSnapshot.size });
            }
  
            // const currentMobile = this.state.filterMobile;
  
            // if(currentMobile === ''){
              this.setState({
                checkIns,
                firstCheckIn: checkInsSnapshot.docs[0],
                lastCheckIn: checkInsSnapshot.docs[checkInsSnapshot.size - 1],
                loading: false,
                loadingLastCheckIn: false,
              });
  
              this.getUserNotes(checkIns);
              this.calcChechInFunc(businessId, siteId);
            // }
  
            if (!this.state.activeCheckIn || this.state.streamActiveCheckIn) {
              this.setActiveCheckIn([{ cols: null, rows: [0, 0] }]);
            }
          },
          (error) => {
            this.setState({ loading: false });
            throw error;
          }
        );
      }


    }
  };

  private getUserNotes = async (checkIns) => {
    if (checkIns) {
      const userNotes: any[] = [];
      // checkIns.forEach((checkIn) => {
      // firestore
      //   .collection("notes")
      //   .where("businessId", "==", checkIn.businessId)
      //   .where("mobile", "==", checkIn.mobile)
      //   .onSnapshot((snapshot) => {
      //     if (!snapshot.empty) {
      //       snapshot.forEach((doc) => {
      //         const noteData = doc.data();
      //         userNotes[checkIn.mobile] = noteData.note;
      //       });
      //     }
      //   });

      for (const checkIn of checkIns) {
        const query = await firestore
          .collection("notes")
          .where("businessId", "==", checkIn.businessId)
          .where("mobile", "==", checkIn.mobile)
          .get();

        query.forEach((doc) => {
          const noteData = doc.data();
          userNotes[checkIn.mobile] = noteData.note;
          this.setState({ userNotes });
        });
      }
      // });
      // this.setState({ userNotes });
    }
  };

  private watchWrenchAPartOptOutsCount = async (businessId, siteId) => {
    const now = new Date();
    const lastMidnight = now.setHours(0, 0, 0, 0);
    console.log(lastMidnight);

    // then convert those to UTC0 to pass on in your query to firestore
    // const lastMidNightUTC = new Date(lastMidnight + now.getTimezoneOffset() * 60000).toString();
    // const today = new Date();
    // let dd: any = today.getDate();
    // let mm: any = today.getMonth() + 1;
    // const yyyy = today.getFullYear();
    // if (dd < 10) {
    //   dd = "0" + dd;
    // }

    // if (mm < 10) {
    //   mm = "0" + mm;
    // }
    // const date = mm + "-" + dd + "-" + yyyy;

    const date = this.calcDate();

    if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", siteId)
        .where("optin", "==", false)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot((snap) => {
          const size = snap.size;
          console.log(snap.size);
          this.setState({ dailyOptOuts: size });
        });
    } else if (siteId === "all") {
      console.log("finding size...");
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("optin", "==", false)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot((snap) => {
          const size = snap.size;
          console.log(snap.size);
          this.setState({ dailyOptOuts: size });
        });
    } else if(siteId === "ogden"){


      firestore
      .collection("checkIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", "6vVH4qpzsVxjmROhMDmh")
      .where("optin", "==", false)
      .where("timestamp", ">=", new Date(date))
      .onSnapshot((snap) => {
        const size = snap.size;
        console.log(snap.size);
        this.setState({ dailyOptOuts: size });
      });

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("optin", "==", false)
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").get();
      // const query2 = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").get();
      // const query3 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }

      // const size = finalArray.length;
      // this.setState({ dailyOptOuts: size });

    } else if(siteId === "slc"){

      firestore
      .collection("checkIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", "kv9ciglhFsJBh9YyV2sd")
      .where("optin", "==", false)
      .where("timestamp", ">=", new Date(date))
      .onSnapshot((snap) => {
        const size = snap.size;
        console.log(snap.size);
        this.setState({ dailyOptOuts: size });
      });

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("optin", "==", false)
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").get();
      // const query2 = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").get();
      // const query3 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const size = finalArray.length;
      // this.setState({ dailyOptOuts: size });

    }
  };

  private watchOptOutsCount = async (businessId, siteId) => {
    if (businessId === "VQMWUEYKKs4rSpAzQ7P2") {
      console.log("WAP...");
      this.watchWrenchAPartOptOutsCount(businessId, siteId);
      return;
    }
    // const now = new Date();
    // const lastMidnight = now.setHours(0, 0, 0, 0);
    // console.log(lastMidnight);

    // // then convert those to UTC0 to pass on in your query to firestore
    // // const lastMidNightUTC = new Date(lastMidnight + now.getTimezoneOffset() * 60000).toString();
    // const today = new Date();
    // let dd: any = today.getDate();
    // let mm: any = today.getMonth() + 1;
    // const yyyy = today.getFullYear();
    // if (dd < 10) {
    //   dd = "0" + dd;
    // }

    // if (mm < 10) {
    //   mm = "0" + mm;
    // }
    // const date = mm + "-" + dd + "-" + yyyy;

    const date = this.calcDate();

    console.log("DAILY OPT OUTS");
    if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", siteId)
        .where("userId", "==", "opt-out")
        .where("timestamp", ">=", new Date(date))
        .onSnapshot((snap) => {
          const size = snap.size;
          console.log(snap.size);
          this.setState({ dailyOptOuts: size });
        });
    } else if (siteId === "all") {
      console.log("finding size...");
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("userId", "==", "opt-out")
        .where("timestamp", ">=", new Date(date))
        .onSnapshot((snap) => {
          const size = snap.size;
          console.log(snap.size);
          this.setState({ dailyOptOuts: size });
        });
    } else if(siteId === "ogden"){

      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", "6vVH4qpzsVxjmROhMDmh")
        .where("userId", "==", "opt-out")
        .where("timestamp", ">=", new Date(date))
        .onSnapshot((snap) => {
          const size = snap.size;
          console.log(snap.size);
          this.setState({ dailyOptOuts: size });
        });

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("userId", "==", "opt-out")
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").get();
      // const query2 = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").get();
      // const query3 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const size = finalArray.length;
      // this.setState({ dailyOptOuts: size });

    } else if(siteId === "slc"){


      firestore
      .collection("checkIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", "kv9ciglhFsJBh9YyV2sd")
      .where("userId", "==", "opt-out")
      .where("timestamp", ">=", new Date(date))
      .onSnapshot((snap) => {
        const size = snap.size;
        console.log(snap.size);
        this.setState({ dailyOptOuts: size });
      });

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("userId", "==", "opt-out")
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").get();
      // const query2 = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").get();
      // const query3 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));
      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const size = finalArray.length;
      // this.setState({ dailyOptOuts: size });

    }
  };



  private async calcChechInFunc(businessId, siteId){
    const date = this.calcDate();
    if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", siteId)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot(snap => {
          const size = snap.size;
          this.setState({ dailyCheckInStat : size });
        });
    } else if (siteId === "all") {
      console.log("finding size...");
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot(snap => {
          const size = snap.size;
          this.setState({ dailyCheckInStat : size });
        });
    } else if(siteId === "ogden"){

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").get();
      // const query2 = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").get();
      // const query3 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const size = finalArray.length;
      // this.setState({ dailyCheckInStat: size });

      firestore
      .collection("checkIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", "6vVH4qpzsVxjmROhMDmh")
      .where("timestamp", ">=", new Date(date))
      .onSnapshot(snap => {
        const size = snap.size;
        this.setState({ dailyCheckInStat : size });
      });


    } else if(siteId === "slc"){

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").get();
      // const query2 = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").get();
      // const query3 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const size = finalArray.length;
      // this.setState({ dailyCheckInStat: size });

      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", "kv9ciglhFsJBh9YyV2sd")
        .where("timestamp", ">=", new Date(date))
        .onSnapshot(snap => {
          const size = snap.size;
          this.setState({ dailyCheckInStat : size });
        });

    }
  }

  private async calcRecheckFunc(businessId, siteId){
    const date = this.calcDate();
    if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", siteId)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot(snap => {
          const userIds:any = [];
          snap.forEach((ele)=>{
            const u = ele.data();
            userIds.push(u.userId); 
          })

          const recheckArr1:any= [];
          const recheckArr2:any= [];
          let countRecheck = 0;
          userIds.forEach((ele)=>{
            const inrecheckArr1 = recheckArr1.includes(ele);
            const inrecheckArr2 = recheckArr2.includes(ele);
            if(!inrecheckArr1){
              recheckArr1.push(ele);
            }else{
              if(!inrecheckArr2){
                recheckArr2.push(ele);
                countRecheck++;
              }
            }
          });

          this.setState({ recheck:countRecheck });
        });
    } else if (siteId === "all") {
      firestore
        .collection("checkIns")
        .where("businessId", "==", businessId)
        .where("timestamp", ">=", new Date(date))
        .onSnapshot(snap => {
          const userIds:any = [];
          snap.forEach((ele)=>{
            const u = ele.data();
            userIds.push(u.userId); 
            // console.log(u);
          })

          const recheckArr1:any= [];
          const recheckArr2:any= [];
          let countRecheck = 0;
          userIds.forEach((ele)=>{
            const inrecheckArr1 = recheckArr1.includes(ele);
            const inrecheckArr2 = recheckArr2.includes(ele);
            if(!inrecheckArr1){
              recheckArr1.push(ele);
            }else{
              if(!inrecheckArr2){
                recheckArr2.push(ele);
                countRecheck++;
              }
            }
          });

          this.setState({ recheck:countRecheck });
        });
    } else if(siteId === "ogden"){

      firestore
      .collection("checkIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", "6vVH4qpzsVxjmROhMDmh")
      .where("timestamp", ">=", new Date(date))
      .onSnapshot(snap => {
        const userIds:any = [];
        snap.forEach((ele)=>{
          const u = ele.data();
          userIds.push(u.userId); 
        })

        const recheckArr1:any= [];
        const recheckArr2:any= [];
        let countRecheck = 0;
        userIds.forEach((ele)=>{
          const inrecheckArr1 = recheckArr1.includes(ele);
          const inrecheckArr2 = recheckArr2.includes(ele);
          if(!inrecheckArr1){
            recheckArr1.push(ele);
          }else{
            if(!inrecheckArr2){
              recheckArr2.push(ele);
              countRecheck++;
            }
          }
        });

        this.setState({ recheck:countRecheck });
      });

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").get();
      // const query2 = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").get();
      // const query3 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const userIds:any = [];
      // finalArray.forEach((ele)=>{
      //   const u = ele.data();
      //   userIds.push(u.mobile); 
      // });

      // const recheckArr1:any= [];
      // const recheckArr2:any= [];
      // let countRecheck = 0;
      // userIds.forEach((ele)=>{
        
      //   const inrecheckArr1 = recheckArr1.includes(ele);
      //   const inrecheckArr2 = recheckArr2.includes(ele);
      //   if(!inrecheckArr1){
      //     recheckArr1.push(ele);
      //   }else{
      //     if(!inrecheckArr2){
      //       recheckArr2.push(ele);
      //       countRecheck++;
      //     }
      //   }
      // });

      // this.setState({ recheck:countRecheck });


    } else if(siteId === "slc"){

      firestore
      .collection("checkIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", "kv9ciglhFsJBh9YyV2sd")
      .where("timestamp", ">=", new Date(date))
      .onSnapshot(snap => {
        const userIds:any = [];
        snap.forEach((ele)=>{
          const u = ele.data();
          userIds.push(u.userId); 
        })

        const recheckArr1:any= [];
        const recheckArr2:any= [];
        let countRecheck = 0;
        userIds.forEach((ele)=>{
          const inrecheckArr1 = recheckArr1.includes(ele);
          const inrecheckArr2 = recheckArr2.includes(ele);
          if(!inrecheckArr1){
            recheckArr1.push(ele);
          }else{
            if(!inrecheckArr2){
              recheckArr2.push(ele);
              countRecheck++;
            }
          }
        });

        this.setState({ recheck:countRecheck });
      });

      // const query :any = firestore.collection("checkIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("timestamp", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").get();
      // const query2 = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").get();
      // const query3 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const userIds:any = [];
      // finalArray.forEach((ele)=>{
      //   const u = ele.data();
      //   userIds.push(u.mobile); 
      // });

      // const recheckArr1:any= [];
      // const recheckArr2:any= [];
      // let countRecheck = 0;
      // userIds.forEach((ele)=>{
      //   const inrecheckArr1 = recheckArr1.includes(ele);
      //   const inrecheckArr2 = recheckArr2.includes(ele);
      //   if(!inrecheckArr1){
      //     recheckArr1.push(ele);
      //   }else{
      //     if(!inrecheckArr2){
      //       recheckArr2.push(ele);
      //       countRecheck++;
      //     }
      //   }
      // });

      // this.setState({ recheck:countRecheck });

    }
    
  }

  private calcDate(funcName=''){
    const { filterStat } = this.state;
    const today = new Date();
    let dd: any;
    let mm: any

    if(filterStat === 'Weekly' && funcName !== 'newcheck'){
      dd = today.getDate() - 6;
    }else{
      dd = today.getDate();
    }
    
    if(filterStat === 'Monthly' && funcName !== 'newcheck'){
      mm = today.getMonth();
      dd = today.getDate()+1;
    }else{
      mm = today.getMonth() + 1;
    }
    

    // let dd: any = today.getDate() - 7;
    // let mm: any = today.getMonth() + 1;
    // let mm: any = today.getMonth();
    const yyyy = today.getFullYear();
    if (dd < 10) {
      dd = "0" + dd;
    }

    if (mm < 10) {
      mm = "0" + mm;
    }
    const date = mm + "-" + dd + "-" + yyyy;
    return date;
  }


  private async newCheckinFunc(businessId, siteId){

    const date = this.calcDate('newcheck');

    let query : any = firestore.collection("checkIns");
    
    if (businessId) {
      query = query.where("businessId", "==", businessId);
    }

    if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
      query = query.where("siteId", "==", siteId);
    }

    if (siteId && siteId === "ogden") {
      query = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh");
    }

    if (siteId && siteId === "slc") {
      query = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd");
    }

    query = query.where("timestamp", ">=", new Date(date));

    query.get().then((ele)=>{
      let newCheckinCount = 0;
      this.setState({ newCheckinCount });
      let i=1;

      ele.forEach((checkIns)=>{
        const checkIn = checkIns.data();

        let innerQuery:any = firestore.collection("checkIns");

        if (businessId) {
          innerQuery = innerQuery.where("businessId", "==", businessId);
        }
    
        if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
          innerQuery = innerQuery.where("siteId", "==", siteId);
        }
        if (siteId && siteId === "ogden") {
          innerQuery = innerQuery.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh");
        }
        if (siteId && siteId === "slc") {
          innerQuery = innerQuery.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd");
        }
        if (checkIn.mobile) {
          innerQuery = innerQuery.where("mobile", "==", checkIn.mobile);
        }
    
        innerQuery = innerQuery.orderBy("timestamp", "asc").limit(1);

        innerQuery.get().then(
          (checkInsSnapshot) => {
            if(checkInsSnapshot.docs[0].data()){
              const joinDate = checkInsSnapshot.docs[0].data().timestamp;
              if(joinDate.isEqual(checkIn.timestamp)){
                newCheckinCount++;
              }
              if((i) === ele.size){
                this.setState({ newCheckinCount });
              }
            }
            i++;
          });
          
      });
    });



  }


  private async voidCheckInFunc(businessId, siteId){
    const date = this.calcDate();
    // console.log("dddddddddddddddddddddddddd");
    // console.log(this.calcDate());
    // const date = '10-13-2021';

    if (siteId && siteId !== "all" && siteId !== "ogden" && siteId !== "slc") {
      const query = firestore
      .collection("voidedCheckIns")
      .where("businessId", "==", businessId)
      .where("siteId", "==", siteId)
      .where("voidedAt", ">=", new Date(date))
      .get();

      query.then((ele)=>{
        this.setState({ voidStat:ele.size });
      });

    } else if (siteId === "all") {
      const query = firestore
      .collection("voidedCheckIns")
      .where("businessId", "==", businessId)
      .where("voidedAt", ">=", new Date(date))
      .get();

      query.then((ele)=>{
        this.setState({ voidStat:ele.size });
      });          
    } else if(siteId === "ogden"){
      
      const query = firestore
        .collection("voidedCheckIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", "6vVH4qpzsVxjmROhMDmh")
        .where("voidedAt", ">=", new Date(date))
        .get();

      query.then((ele)=>{
        this.setState({ voidStat:ele.size });
      });

      // const query :any = firestore.collection("voidedCheckIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("voidedAt", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "TMrSaHl6j451pEWxY7nu").get();
      // const query2 = query.where("siteId", "==", "6vVH4qpzsVxjmROhMDmh").get();
      // const query3 = query.where("siteId", "==", "1YYyeZ1YXjGyc6Z6vwRt").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const size = finalArray.length;
      // this.setState({ voidStat: size });

    } else if(siteId === "slc"){


      const query = firestore
        .collection("voidedCheckIns")
        .where("businessId", "==", businessId)
        .where("siteId", "==", "kv9ciglhFsJBh9YyV2sd")
        .where("voidedAt", ">=", new Date(date))
        .get();

      query.then((ele)=>{
        this.setState({ voidStat:ele.size });
      });

      // const query :any = firestore.collection("voidedCheckIns")
      //                 .where("businessId", "==", businessId)
      //                 .where("voidedAt", ">=", new Date(date));
      // const query1 = query.where("siteId", "==", "FDYHKAMSiYNCuXumk5Iv").get();
      // const query2 = query.where("siteId", "==", "kv9ciglhFsJBh9YyV2sd").get();
      // const query3 = query.where("siteId", "==", "17VBJyeH2crmqQC2OSxx").get();

      // const [c1, c2, c3]  = await Promise.all([query1,query2, query3]);

      // const c1Array = c1.docs;
      // const c2Array = c2.docs;
      // const c3Array = c3.docs;

      // // const finalArray = c3Array.concat(c2Array.concat(c1Array));

      // let finalArray:any = [];

      // if(c3Array && typeof c3Array !== 'undefined'){
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c2Array.concat(c1Array));
      //     }else{
      //       finalArray = c3Array.concat(c2Array);
      //     }
      //   }else{
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c3Array.concat(c1Array);
      //     }else{
      //       finalArray = c3Array;
      //     }
      //   }
      // }else{
      //   if(c2Array && typeof c2Array !== 'undefined'){
      //     if( c1Array && typeof c1Array !== "undefined"){
      //       finalArray = c2Array.concat(c1Array);
      //     }else{
      //       finalArray = c2Array;
      //     }
      //   }
      // }


      // const size = finalArray.length;
      // this.setState({ voidStat: size });

    }

  }

  private handleNewKioskSelection = ({ businessId, businessPath, siteId, sitePath }: Selected) => {
    const { dailyCheckInsSubscription } = this.props;
    const { siteId: siteIdState, businessId: businessIdState } = this.state;
    if (this.unsubscribe) {
      this.unsubscribe();
    }

    if (businessId) {
      this.setState({ businessId, businessPath, siteId, sitePath });
      this.watchCheckIns(businessId, siteId);
      this.watchOptOutsCount(businessId, siteId);
    }

    if ((siteId && siteId !== siteIdState) || (businessId && businessId !== businessIdState)) {
      if (dailyCheckInsSubscription) {
        dailyCheckInsSubscription();
      }

      if (!businessId) {
        businessId = "";
      }

      this.getBussData(businessId);
      watchDailyCheckIns(siteId, businessId);
    }

    const scrollbox = document.querySelector("#chkinwrap_main_block .bp3-table-quadrant-scroll-container");
    if (scrollbox && scrollbox.scrollTop) {
      scrollbox.scrollTop = 0;
    }

  };

  private getBussData = async (businessId) => {
    const doc = await firestore
      .collection(`businesses`)
      .doc(businessId)
      .get();
    
    const { modeArr }  = this.state; 
    const businessData: any = doc.data();
    const darkmode = businessData.darkmode ? "#313030" : "#E5E5E5";
    this.setState({ darkmode });

    const matches = document.getElementsByClassName("css-1k7bvv7");
    const actchkblockblank = document.getElementsByClassName("active_chkin_main_block");
    const headerblock = document.getElementById("header_dm_block");
    // const waiverBlock = document.querySelector<HTMLElement>("#waiver_block")!;
    const actchkinwrap = document.getElementById("act-checkin-wrap");
    const actchkblock = document.getElementById("print");
    const noteblock = document.getElementById("note-style1");
    const notecolormodeblock = document.querySelector<HTMLElement>("#note-style1")!;
    const vehicledmblock = document.getElementById("vehicle_dm_block");
    const actchktable = document.getElementById("chkinwrap_main_block");
    // class const
    const bodyBlock =  document.querySelector<HTMLElement>('body')!;
    const namePhoneBlock =  document.querySelector<HTMLElement>('#name_phone_block')!;
    const mainContainer =  document.querySelector<HTMLElement>('.css-1k7bvv7')!;
    const chkinwrapMainBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block')!;
    const leftSideTagBlock =  document.querySelectorAll<HTMLElement>('#chkinwrap_main_block #active-checkin-style .bp3-tag')!;
    const tableBackgroundBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block .bp3-table-quadrant-scroll-container')!;
    const tableColumBlock =  document.querySelectorAll<HTMLElement>('#chkinwrap_main_block .bp3-table-top-container .table_base, #chkinwrap_main_block .bp3-table-quadrant-scroll-container')!;
    const tableColumBorderBlock =  document.querySelectorAll<HTMLElement>('#chkinwrap_main_block .bp3-table-top-container .table_base')!;
    const leftSideBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #print')!;
    // const leftSideH4FontBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #print h4')!;
    const leftSideParagraphFontBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #print p')!;
    const leftSideFeildBlock =  document.querySelectorAll<HTMLElement>('#chkinwrap_main_block #active-checkin-style .bp3-text-overflow-ellipsis.bp3-fill')!;
    const leftSideMobileBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block .bp3-tag.bp3-minimal .bp3-text-overflow-ellipsis.bp3-fill')!;
    const filterButtonBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #filter-sec-style .bp3-control-group .bp3-button')!;
    // const filterStatButtonBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #filter-stat-style .bp3-control-group .bp3-button')!;
    const corgButtonBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #act-checkin-wrap .bp3-control-group .bp3-button .bp3-icon')!;
    const dailyCntBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #daily-cnt-style .bp3-tag')!;
    const dailyCntOutBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #daily-cnt-style')!;
    const dailyKiskBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #daily-kisk-style .bp3-tag')!;
    const dailyKiskOutBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #daily-kisk-style')!;
    const reCheckStyleBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #re-check-style .bp3-tag')!;
    const reCheckStyleOutBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #re-check-style')!;
    const voidStatStyleBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #void-stat-style .bp3-tag')!;
    const voidStatStyleOutBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #void-stat-style')!;
    const newCustomerStyleBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #new-customer-style .bp3-tag')!;
    const newCustomerStyleOutBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #new-customer-style')!;
    const filterSecBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #filter-sec-style .bp3-html-select select')!;
    const filterStatSecBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #filter-stat-style .bp3-html-select select')!;
    const filterByDateBlock =  document.querySelectorAll<HTMLElement>('#chkinwrap_main_block #filter-date-style .css-dbagas .bp3-button')!;
    const filterByDateChildBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #filter-date-style .css-dbagas .bp3-button .bp3-icon.bp3-icon-document')!;
    const calenderBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #calender-style .bp3-button')!;
    const rowsOfTableBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #rows_of_table')!;
    const leftSideDownloadBtnBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #download-style .bp3-button')!;
    const leftSideNoteBtnBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #note-style .bp3-button')!;
    // const activeChkinMainBlock =  document.querySelector<HTMLElement>('.active_chkin_main_block')!;

    // mark for theft switch
    const markfortheftswitchBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #markfortheftswitch')!;
    let markfortheftswitchState = false;
    if(businessData.markForTheftSwitch !== undefined && businessData.markForTheftSwitch){
      markfortheftswitchState = businessData.markForTheftSwitch;
    }

    if(markfortheftswitchBlock){
      markfortheftswitchBlock.style.display = markfortheftswitchState ? "block":"none";
    }

    // Military First Resopnder Switch
    const militaryFirstResopnderSwitchBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #militaryFirstResopnderSwitch')!;
    let militaryFirstResopnderSwitchState = false;
    if(businessData.militaryFirstResopnderSwitch !== undefined && businessData.militaryFirstResopnderSwitch){
      militaryFirstResopnderSwitchState = businessData.militaryFirstResopnderSwitch;
    }

    if(militaryFirstResopnderSwitchBlock){
      militaryFirstResopnderSwitchBlock.style.display = militaryFirstResopnderSwitchState ? "block":"none";
    }

    // mark for selling car switch
    const markforsellingcarswitchBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #markforsellingcarswitch')!;
    let markforsellingcarswitchState = false;
    if(businessData.markForSellingCarSwitch !== undefined && businessData.markForSellingCarSwitch){
      markforsellingcarswitchState = businessData.markForSellingCarSwitch;
    }

    if(markforsellingcarswitchBlock){
      markforsellingcarswitchBlock.style.display = markforsellingcarswitchState ? "block":"none";
    }

    // Add new Pick switch
    const addaNewPickSwitchBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #addaNewPickSwitch')!;
    let addaNewPickSwitchState = false;
    if(businessData.addaNewPickSwitch !== undefined && businessData.addaNewPickSwitch){
      addaNewPickSwitchState = businessData.addaNewPickSwitch;
    }

    if(addaNewPickSwitchBlock){
      addaNewPickSwitchBlock.style.display = addaNewPickSwitchState ? "block":"none";
    }

    // To hide swith block when theft and cast switches are disabled
    const leftSideSwitchBlock =  document.querySelector<HTMLElement>('#chkinwrap_main_block #left_side_theft_n_cash_btn_block')!;
    leftSideSwitchBlock.style.display = (markforsellingcarswitchState || markfortheftswitchState) ? "inline-flex":"none";

    if(businessData.colormode !== undefined && businessData.colormode){

      // style data
      let mainBackground = "#E5E5E5";
      if(businessData.checkInsOptions.mainBackgroundColor !== undefined){
        mainBackground = businessData.checkInsOptions.mainBackgroundColor;
      }

      bodyBlock.style.background = mainBackground;

      let tableBackground = '#fff';
      if(businessData.checkInsOptions.tableBackgroundColor !== undefined){
        tableBackground = businessData.checkInsOptions.tableBackgroundColor;
      }

      let tableBorder = '#d2d6d9';
      if(businessData.checkInsOptions.tableBorderColor !== undefined){
        tableBorder = businessData.checkInsOptions.tableBorderColor;
      }

      let leftSideBgColor = '#fff';
      if(businessData.checkInsOptions.leftSideBgColor !== undefined){
        leftSideBgColor = businessData.checkInsOptions.leftSideBgColor;
      }

      let leftSideTagBackground = '#5c7080';
      if(businessData.checkInsOptions.leftSideTagColor !== undefined){
        leftSideTagBackground = businessData.checkInsOptions.leftSideTagColor;
      }

      let tableFont = '#182026';
      if(businessData.checkInsOptions.tableFontColor !== undefined){
        tableFont = businessData.checkInsOptions.tableFontColor;
      }

      let buttonColor = '#0d47f0';
      if(businessData.checkInsOptions.buttonColor !== undefined){
        buttonColor = businessData.checkInsOptions.buttonColor;
      }

      // before apply
      
      if (actchkblock) {
        actchkblock.classList.remove("act_chk_main_block_style");
      }

      // apply style
      mainContainer.style.background = mainBackground;
      chkinwrapMainBlock.style.background = mainBackground;
      tableBackgroundBlock.style.background = tableBackground;
      tableColumBlock.forEach((ele)=>{
        ele.style.background = tableBackground;
        ele.style.color = tableFont;
        ele.style.border = "1px solid "+ tableBorder;
      });
      let i = 0;
      let child;
      leftSideTagBlock.forEach((ele)=>{
        if((i % 2 === 0)){
          ele.style.background = leftSideTagBackground;
          ele.style.color = tableFont;
        }
        child = ele.firstChild?ele.firstChild.textContent:'';
        if(child === 'Coupons'){
          i = i + 2;            
        }else{
          i = i+1;
        }
      });
      leftSideBlock.style.background = leftSideBgColor;
      leftSideBlock.style.color = tableFont;
      namePhoneBlock.style.color = tableFont;
      notecolormodeblock.style.color = tableFont;
      // leftSideH4FontBlock.style.color = tableFont;
      leftSideMobileBlock.style.color = tableFont;
      if(leftSideParagraphFontBlock !== undefined && leftSideParagraphFontBlock){
        leftSideParagraphFontBlock.style.color = tableFont;
      }
      leftSideFeildBlock.forEach((ele)=>{
        ele.style.color = tableFont;
      })
      filterButtonBlock.style.background = buttonColor;
      // filterStatButtonBlock.style.background = buttonColor;
      dailyCntBlock.style.background = buttonColor;
      dailyCntOutBlock.style.border = "1px solid " + buttonColor;
      dailyKiskBlock.style.background = buttonColor;
      reCheckStyleBlock.style.background = buttonColor;
      voidStatStyleBlock.style.background = buttonColor;
      newCustomerStyleBlock.style.background = buttonColor;
      dailyKiskOutBlock.style.border = "1px solid " + buttonColor;
      reCheckStyleOutBlock.style.border = "1px solid " + buttonColor;
      voidStatStyleOutBlock.style.border = "1px solid " + buttonColor;
      newCustomerStyleOutBlock.style.border = "1px solid " + buttonColor;
      corgButtonBlock.style.color = buttonColor;
      filterSecBlock.style.background = buttonColor;
      filterStatSecBlock.style.background = buttonColor;
      filterStatSecBlock.style.color = tableFont;
      calenderBlock.style.background = buttonColor;
      rowsOfTableBlock.style.background = buttonColor;
      leftSideDownloadBtnBlock.style.background = buttonColor;
      leftSideNoteBtnBlock.style.background = "#0D8050";
      
      filterByDateBlock.forEach((ele,index)=>{
        if(index === 0){
          ele.style.background = '#51659b';
        }else if(index === 1){
          ele.style.background = '#fff';
          ele.style.color = '#8090b5'
          ele.style.removeProperty('border');
        }else{
          ele.style.background = buttonColor;
        }
      });
      
      tableColumBorderBlock.forEach((ele)=>{
        ele.style.border= "0.1px solid " + tableBorder;
      });

      filterByDateChildBlock.style.removeProperty("color");

      modeArr.mode = 'colorMode';
      modeArr.background = buttonColor;
      modeArr.fontColor = tableFont;
      modeArr.tableBgColor = tableBackground;
      modeArr.tableFontColor = tableFont;
      modeArr.tableBorder = "1px solid "+ tableBorder;
      // this.setState

    }else{
      modeArr.mode = 'noMode';
      modeArr.background = "#0d47f0";
      modeArr.fontColor = "#fff";
      modeArr.tableBgColor = "#f5f8fa";
      modeArr.tableFontColor = "#182026";
      modeArr.tableBorder = "1px solid #d2d6d9";
      
      // remove style
      mainContainer.style.removeProperty("background");
      chkinwrapMainBlock.style.removeProperty("background");
      tableBackgroundBlock.style.removeProperty("background");
      leftSideBlock.style.removeProperty("background");


      let i = 0;
      let child;
      leftSideTagBlock.forEach((ele)=>{
        if(i % 2 === 0){
          ele.style.removeProperty("background");
          ele.style.removeProperty("color");
        }
        child = ele.firstChild?ele.firstChild.textContent:'';
        if(child === 'Coupons'){
          i = i + 2;            
        }else{
          i++;
        }
      });
      // tableColumBlock.forEach((ele)=>{
      //   ele.style.removeProperty("background");
      //   ele.style.removeProperty("color");
      // });
      // tableColumBlock.style.removeProperty("color");
      leftSideBlock.style.removeProperty("color");
      notecolormodeblock.style.removeProperty("color");
      // leftSideH4FontBlock.style.removeProperty("color");
      
      if(leftSideParagraphFontBlock !== undefined && leftSideParagraphFontBlock){
        leftSideParagraphFontBlock.style.removeProperty("color");
      }
      leftSideFeildBlock.forEach((ele)=>{
        ele.style.removeProperty("color");
      })        
      filterButtonBlock.style.background= '#0d47f0';
      // filterStatButtonBlock.style.background= '#0d47f0';
      dailyCntBlock.style.background= '#0d47f0';
      dailyCntOutBlock.style.border= '1px solid #0D47F0';
      dailyKiskBlock.style.background= '#0d47f0';
      reCheckStyleBlock.style.background= '#0d47f0';
      voidStatStyleBlock.style.background= '#0d47f0';
      newCustomerStyleBlock.style.background= '#0d47f0';
      dailyKiskOutBlock.style.border= '1px solid #0D47F0';
      reCheckStyleOutBlock.style.border= '1px solid #0D47F0';
      voidStatStyleOutBlock.style.border= '1px solid #0D47F0';
      newCustomerStyleOutBlock.style.border= '1px solid #0D47F0';
      leftSideMobileBlock.style.removeProperty("color");
      corgButtonBlock.style.removeProperty("color");
      filterSecBlock.style.background= '#0d47f0';
      filterStatSecBlock.style.background= '#0d47f0';
      filterStatSecBlock.style.color= '#fff';
      calenderBlock.style.background= '#0d47f0';
      rowsOfTableBlock.style.background= '#0d47f0';
      leftSideDownloadBtnBlock.style.background= '#0d47f0';
      leftSideNoteBtnBlock.style.background= '#0D8050';
      filterByDateBlock.forEach((ele,index)=>{
        if(index === 0){
          ele.style.background = '#51659b';
        }else if(index === 1){
          ele.style.background = '#fff';
          ele.style.color = '#8090b5';
          ele.style.removeProperty('border');
        }else{
          ele.style.background = '#0d47f0';
        }
      });

      tableColumBorderBlock.forEach((ele)=>{
        ele.style.border = businessData.darkmode? "1px solid #3f3737" : '1px solid #d2d6d9';
      });


      // darkmode and normal mode start
      if (businessData.darkmode) {
        bodyBlock.style.background = '#313030';
        namePhoneBlock.style.color = '#fff';
        matches[0].classList.add("css-1k7bvv71");
        if (actchkblock) {
          actchkblock.classList.add("act_chk_main_block_style");
        }
        if (actchkblockblank[0]) {
          actchkblockblank[0].classList.add("act_chk_blank_main_block_style");
        }
        if (actchktable) {
          actchktable.classList.add("act_chk_table");
        }
        if (vehicledmblock) {
          vehicledmblock.classList.add("actchkvehiclestyle");
        }
        if (actchkinwrap) {
          actchkinwrap.classList.add("act_chkin_wrap_cog");
        }
        if (noteblock) {
          noteblock.classList.add("note-font-color");
        }

        tableColumBlock.forEach((ele)=>{
          ele.style.background = "#5C7080";
          ele.style.color = "#fff";
          ele.style.border = "1px solid #a7a4a4";
        });

        filterByDateBlock.forEach((ele,index)=>{
          if(index === 0){
            ele.style.background = '#5C7080';
          }else if(index === 1){
            filterByDateBlock[1].style.background = '#5C7080';
            filterByDateBlock[1].style.color = '#fff';
            filterByDateBlock[1].style.border = '1px solid #fff';
            filterByDateChildBlock.style.color = "#fff";
          }else{
            ele.style.background = '#9B9B9B';
          }
        });

        filterButtonBlock.style.background = "#9B9B9B";
        // filterStatButtonBlock.style.background = "#9B9B9B";
        dailyCntBlock.style.background = "#9B9B9B";
        dailyCntOutBlock.style.border = "1px solid #9B9B9B";
        dailyKiskBlock.style.background = "#9B9B9B";
        reCheckStyleBlock.style.background = "#9B9B9B";
        voidStatStyleBlock.style.background = "#9B9B9B";
        newCustomerStyleBlock.style.background = "#9B9B9B";
        dailyKiskOutBlock.style.border = "1px solid #9B9B9B";
        reCheckStyleOutBlock.style.border = "1px solid #9B9B9B";
        voidStatStyleOutBlock.style.border = "1px solid #9B9B9B";
        newCustomerStyleOutBlock.style.border = "1px solid #9B9B9B";
        filterSecBlock.style.background = "#9B9B9B";
        filterStatSecBlock.style.background = "#9B9B9B";
        filterStatSecBlock.style.color = "#fff";
        calenderBlock.style.background = "#9B9B9B";
 
        rowsOfTableBlock.style.background = "#9B9B9B";
        
        modeArr.mode = 'darkMode';
        modeArr.background = "#9B9B9B";
        modeArr.fontColor = "#fff";
        modeArr.tableBgColor = "#5C7080";
        modeArr.tableFontColor = "#fff";
        modeArr.tableBorder = "1px solid #a7a4a4";

      } else {
        bodyBlock.style.background = '#e5e5e5';
        matches[0].classList.remove("css-1k7bvv71");
        if (actchkblock) {
          actchkblock.classList.remove("act_chk_main_block_style");
        }
        if (actchkblockblank[0]) {
          actchkblockblank[0].classList.remove("act_chk_blank_main_block_style");
        }
        if (actchktable) {
          actchktable.classList.remove("act_chk_table");
        }
        if (headerblock) {
          headerblock.classList.remove("act_chk_head");
        }
        if (vehicledmblock) {
          vehicledmblock.classList.remove("actchkvehiclestyle");
        }

        if (actchkinwrap) {
          actchkinwrap.classList.remove("act_chkin_wrap_cog");
        }
        if (noteblock) {
          noteblock.classList.remove("note-font-color");
        }
        // waiverBlock.style.border = "none";
        // waiverBlock.style.width = "100%";
        // waiverBlock.style.padding = "0";
        tableColumBlock.forEach((ele)=>{
          ele.style.removeProperty("background");
          ele.style.removeProperty("color");
          ele.style.border = "1px solid #d2d6d9";
        });
        filterByDateChildBlock.style.removeProperty("color");
        namePhoneBlock.style.removeProperty("color");
  
      }
    }
    
    this.setState({ modeArr });
  };

  private getRowData = (rowIndex: number) => {
    const { checkIns } = this.state;

    if (checkIns[rowIndex]) {
      return checkIns[rowIndex];
    } else {
      return undefined;
    }
  };

  private setActiveCheckIn = async (regions: IRegion[]) => {
    const region = regions[0];

    const leftTableReload = this.state.leftTableReload;

    if (region && leftTableReload) {
    // if (region && ((scrollbox && !scrollbox.scrollTop))) {
      const rowIndex = region.rows && region.rows[0];

      if (rowIndex || rowIndex === 0) {
        const checkIn = this.getRowData(rowIndex) || null;

        if (checkIn) {
      

          // firestore
          // .collection(`membership`)
          // .doc(checkIn.businessId)
          // .onSnapshot(
          //   snapshot => {
          //     if (snapshot.exists) {
          //       const membership = snapshot.data() as Users.Membership;
          //       checkIn.membership = membership;
          //     }
          //     if (rowIndex === 0) {
          //       this.setState({ activeCheckIn: checkIn, streamActiveCheckIn: false });
          //       setTimeout(() => {
          //         this.setState({ streamActiveCheckIn: true });
          //       }, 15000);
          //     } else {
          //       this.setState({ activeCheckIn: checkIn });
          //     }
          //   },
          //   error => {
          //     throw error;
          //   }
          // )
          if (rowIndex === 0) {
            this.setState({
              activeCheckIn: checkIn,
              streamActiveCheckIn: false,
            });
            setTimeout(() => {
              this.setState({ streamActiveCheckIn: true });
            }, 15000);
          } else {
            this.setState({ activeCheckIn: checkIn });
          }
        }
      }
    }
    this.setState({ leftTableReload : true });
  };

  private clearTestCheckIns = async () => {
    try {
      const query = await firestore
        .collection("checkIns")
        .where("zip", "==", "test")
        .get();

      query.forEach((doc) => doc.ref.delete());
    } catch (error) {
      throw new Error(error);
    }
  };
}

const mapStateToProps = ({
  businesses: { businesses, businessPermissions },
  checkIns: { dailyCheckIns, dailyCheckInsSubscription },
  users: { currentUser },
}: IState) => ({
  businessPermissions,
  businesses,
  currentUser,
  dailyCheckIns,
  dailyCheckInsSubscription,
});

export * from "./helpers";

export default connect<ICheckInsStateProps>(mapStateToProps)(CheckIns);



// WEBPACK FOOTER //
// ./src/views/CheckIns/index.tsx